/*!
 * Copyright © 2025 Actavivo
 */
import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";
import { AVEntity } from "./AVEntity";

/** Fundraising campaign API client: manage participants, donation edits, visibility hide lists, and initiate payment requests to the collect endpoint. */
export class Collect extends AVEntity {
	static _collectApi = "/api/Collect";

	public static async addParticipant(source: AV.IFK, target: AV.ILink): Promise<AV.ICollect> {
		return await Server.post(this._collectApi + "/AddParticipant", { source: source, target: target });
	}
	public static async removeParticipant(source: AV.IFK, target: AV.ILink): Promise<AV.ICollect> {
		return await Server.post(this._collectApi + "/RemoveParticipant", { source: source, target: target });
	}
	public static async updateParticipant(source: AV.IFK, target: AV.ICollectLink): Promise<AV.ICollect> {
		var param: AV.ICollectParam = { source: source, target: target };
		return await Server.post(this._collectApi + "/UpdateParticipant", param);
	}
	public static async editDonation(
		source: AV.IFK,
		participant: AV.ILink,
		donation: AV.IDonationLink,
	): Promise<AV.ICollect> {
		var param: AV.IDonationParam = { source: source, paticipant: participant, donation: donation };
		return await Server.post(this._collectApi + "/EditDonation", param);
	}
	public static async addHideFrom(source: AV.IFK, target: AV.ILink[]): Promise<AV.ICollect> {
		var param: AV.IListLinkParam = { source: source, target: target };
		return await Server.post(this._collectApi + "/AddHideFrom", param);
	}
	public static async removeHideFrom(source: AV.IFK, target: AV.ILink[]): Promise<AV.ICollect> {
		var param: AV.IListLinkParam = { source: source, target: target };
		return await Server.post(this._collectApi + "/RemoveHideFrom", param);
	}
	public static async requestPayment(payment: AV.IPayment): Promise<AV.IPayResultResp> {
		//
		return await Server.post(this._collectApi + "/RequestPayment", payment);
	}
}
